module.exports = __webpack_public_path__ + "static/img/20020 (3).d930267.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20020 (3).webp
// module id = vApm
// module chunks = 14